import axios from "axios";

import vue from "../../main";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN,
  removeAllCookie,
  toLogin
} from "../../utils/loginUtils";
import Cookie from "js-cookie";

const tokenStance = axios.create({
  withCredentials: true,
  baseURL: window._env_.BASE_APIS,
  headers: { "Content-Type": "application/json" }
});
// http请求拦截
tokenStance.interceptors.request.use(
  async config => {
    config.headers.sysId = "be7b21f00c034675a75a270257275f24";
    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: "be7b21f00c034675a75a270257275f24",
      accessKeySecret: "9174A3DE0A8940E2B1741324FBA75339"
    });
    await handleAxiosAndRouterToken();
    // 这个地方的时候必有token
    config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
tokenStance.interceptors.response.use(
  res => {
    switch (res.data.status) {
      case "200":
        break;
      case "403":
        removeAllCookie();
        toLogin();
        break;
      case "88888":
        if (window._env_.ENV === "pro") {
          window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        } else {
          window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        }
        break;
      default:
        vue.$notify({
          title: res.data.err,
          type: "error"
        });
    }
    return res;
  },
  error => {
    if (error.response.status && error.response.status === 504) {
      vue.$message.error("Gateway Timeout, Please Try Again Later.");
    }
  }
);
export default {
  tokenStance: tokenStance,
  FORM_HEADER: {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  },
  // 用cookies获取token
  postGenerate: params =>
    tokenStance.post(
      `/partners-center-admin/userAuthority/token/generate`,
      params
    )
  //大区经理审批  回显
  // getContentPermissions: (id) => axios.get("/partner/baseinfo/" + id),
};



// WEBPACK FOOTER //
// ./src/api/fileAxios/token.js